import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import * as $ from "jquery";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})

export class MainComponent implements OnInit, OnDestroy {

  menuOpened: boolean = true;
  private unsubscribe$ = new Subject<void>();
  private mobileBreakpoint = 700; // Definido conforme o CSS existente

  constructor(
    private router: Router,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.setInitialMenuState();
    this.listenToRouterEvents();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /**
   * Define o estado inicial do menu baseado no tamanho da tela
   */
  private setInitialMenuState(): void {
    this.menuOpened = !this.isMobile();
  }

  /**
   * Verifica se a tela está em modo mobile
   */
  private isMobile(): boolean {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  /**
   * Escuta eventos de navegação para fechar o menu automaticamente no mobile
   */
  private listenToRouterEvents(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        // Fecha o menu automaticamente após navegação no mobile
        if (this.isMobile()) {
          this.closeMenu();
        }
      });
  }

  /**
   * Toggle do menu com comportamento otimizado para mobile
   */
  toggleMenu(): void {
    this.menuOpened = !this.menuOpened;
  }

  /**
   * Fecha o menu programaticamente (usado principalmente no mobile)
   */
  closeMenu(): void {
    if (this.menuOpened) {
      this.menuOpened = false;
    }
  }

  /**
   * Fecha o menu quando clicar no backdrop (apenas mobile)
   * O backdrop já está configurado com (click)="toggleMenu()" no template
   */

  /**
   * Ajusta o estado do menu quando redimensionar a tela
   */
  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    // Debounce para evitar muitas execuções durante redimensionamento
    setTimeout(() => {
      if (!this.isMobile() && !this.menuOpened) {
        // Em telas desktop, menu deve estar sempre aberto
        this.menuOpened = true;
      } else if (this.isMobile() && this.menuOpened) {
        // Em telas mobile, menu deve estar fechado por padrão
        this.closeMenu();
      }
    }, 100);
  }
}
